import styled from 'styled-components';
import { Layout } from 'antd';
import { AppBox } from './boxes/AppBox';

const StyledLayout = styled(Layout)({});

export function AppLayout(props) {
  return <AppBox {...props} as={StyledLayout} />;
}
